import {Order} from "./order";

export interface Payment {
    Id: string;
    UserName: string;
    Sub: string;
    Amount: number;
    CreatedAt: Date;
    CreatedByName: string;
    CreatedByUserName: string;
    CreatedBySub: string;
}

export class PaymentFormValues implements Partial<Payment>{
    Id = '';
    UserName='';
    Sub='';
    Amount =0;
    CreatedAt = new Date();
    CreatedByName='';
    CreatedByUserName='';
    CreatedBySub='';


    constructor(init?: Partial<Payment>) {
        Object.assign(this, init);
    }
}